"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEnrichAIPath = exports.STRATEGY_MATRIX_PATH = exports.ENRICH = exports.EnrichSection = void 0;
// eslint-disable-next-line import/prefer-default-export
var EnrichSection;
(function (EnrichSection) {
    EnrichSection["Curation"] = "curation";
    EnrichSection["Dashboards"] = "dashboards";
    EnrichSection["Libraries"] = "libraries";
    EnrichSection["MyWork"] = "mywork";
    EnrichSection["Notifications"] = "notifications";
    EnrichSection["ProductEditor"] = "producteditor";
    EnrichSection["Strategy"] = "strategy";
    EnrichSection["EnrichAI"] = "enrichai";
    EnrichSection["StrategyMatrix"] = "strategy-matrix";
    EnrichSection["Workspace"] = "workspace";
    EnrichSection["HLQATaskView"] = "hlqa";
})(EnrichSection || (exports.EnrichSection = EnrichSection = {}));
exports.ENRICH = 'enrich';
exports.STRATEGY_MATRIX_PATH = `/${exports.ENRICH}/${EnrichSection.EnrichAI}/${EnrichSection.StrategyMatrix}`;
const getEnrichAIPath = (enrichAIPath, searchParams = '') => `/${exports.ENRICH}/${EnrichSection.EnrichAI}/${enrichAIPath}${searchParams}`;
exports.getEnrichAIPath = getEnrichAIPath;
